import type { Brand, BrandColorKey, BrandDarkColorKey } from './types'

export const BRAND_COLOR_KEYS: BrandColorKey[] = ['primary', 'primaryFg', 'accent', 'accentFg', 'surface', 'sidebar']

export const DARK_COLOR_KEYS: Record<BrandColorKey, BrandDarkColorKey> = {
  primary: 'primaryDark',
  primaryFg: 'primaryFgDark',
  accent: 'accentDark',
  accentFg: 'accentFgDark',
  surface: 'surfaceDark',
  sidebar: 'sidebarDark',
}

export const OPTIONAL_BRAND_COLOR_KEYS = new Set<keyof Brand>(['sidebar', ...Object.values(DARK_COLOR_KEYS)])
